import {
  sourceAuthorityNodeKindLabels,
  sourceRelationshipLabel,
  type SourceAuthorityGraph,
} from "@/lib/source-authority";

type SourceRelationshipPanelProps = {
  graph: SourceAuthorityGraph;
  sourceId: string;
  compact?: boolean;
  onOpenSource?: (id: string) => void;
};

export default function SourceRelationshipPanel({
  graph,
  sourceId,
  compact = false,
  onOpenSource,
}: SourceRelationshipPanelProps) {
  const nodeById = new Map(graph.nodes.map((node) => [node.id, node]));
  const relationships = graph.relationships.filter(
    (relationship) => relationship.from === sourceId || relationship.to === sourceId,
  );
  if (!relationships.length) return null;

  return (
    <section className="source-authority-map" aria-label="Source identity and authority relationships">
      <header>
        <div>
          <strong>Relationships</strong>
        </div>
        <span>{relationships.length} registered</span>
      </header>
      <div className="source-authority-records">
        {(compact ? relationships.slice(0, 3) : relationships).map((relationship) => {
          const outgoing = relationship.from === sourceId;
          const other = nodeById.get(outgoing ? relationship.to : relationship.from);
          if (!other) return null;
          const internalHref = other.connectorId ? `#source-${other.connectorId}` : null;
          return (
            <article key={relationship.id}>
              <div>
                <span>{sourceRelationshipLabel(relationship, sourceId)}</span>
                <a
                  href={internalHref ?? other.url}
                  onClick={event => { if (other.connectorId && onOpenSource) { event.preventDefault(); onOpenSource(other.connectorId); } }}
                  target={internalHref ? undefined : "_blank"}
                  rel={internalHref ? undefined : "noreferrer"}
                >
                  {other.label}
                </a>
              </div>
              <details><summary>View evidence</summary><p>{relationship.rationale}</p>
              <footer>
                <span>
                  {sourceAuthorityNodeKindLabels[other.kind]} · {relationship.confidence} confidence · {relationship.state}
                </span>
                <a href={relationship.evidence[0].url} target="_blank" rel="noreferrer">
                  Evidence
                </a>
              </footer></details>
            </article>
          );
        })}
      </div>
    </section>
  );
}
